import { Component, computed, inject, signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { BrandingService } from '@next/core-lib/branding';
import { distinctUntilChanged, shareReplay, switchMap } from 'rxjs/operators';

import { ObservableTableDataSource } from '../../../shared/table/observable-table-data-source';
import { EmployeeListItem } from '../../models/employee.model';
import { EmployeeService } from '../../services/employee.service';

@Component({
  selector: 'app-employee-overview',
  templateUrl: './employee-overview.component.html',
  styleUrls: ['./employee-overview.component.scss'],
  standalone: false,
})
export class EmployeeOverviewComponent {
  private readonly employeeService = inject(EmployeeService);
  private readonly brandingService = inject(BrandingService);
  private readonly router = inject(Router);
  readonly searchText = signal('');
  readonly displayedColumns = ['name', 'email'];

  readonly employees$ = toObservable(this.searchText).pipe(
    distinctUntilChanged(),
    switchMap((query) => this.employeeService.searchEmployees(query?.trim() ?? '')),
    shareReplay({ bufferSize: 1, refCount: true }),
  );
  readonly employeesDataSource = new ObservableTableDataSource(this.employees$);
  readonly employees = toSignal(this.employees$, {
    initialValue: undefined as EmployeeListItem[] | undefined,
  });
  readonly emptyEmployees = computed(() => (this.employees() ?? []).length === 0);
  readonly isAgrifirm = this.brandingService.isTenant('Agrifirm');

  getName(employee: EmployeeListItem) {
    return [employee.firstName, employee.lastName].filter(Boolean).join(' ');
  }

  openEmployee(employee: EmployeeListItem) {
    this.router.navigate(['/employees', employee.employeeId]);
  }

  searchValueChanged(searchValue: string) {
    this.searchText.set(searchValue ?? '');
  }
}
